import React, { useCallback, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import axiosInterceptor from '../../services/axiosInterceptor';

const ResultCard = ({ title }) => {
    const [showCode, setShowCode] = useState(false);
    const [requiredGiftcard, setRequiredGiftcard] = useState('');
    const [optionalGiftcard, setOptionalGiftcard] = useState('');
    const [required, setRequired] = useState([]);
    const [optional, setOptional] = useState([]);
    const [requiredGiftcardAdditional, setRequiredGiftcardAdditional] =
        useState('');
    const [optionalGiftcardAdditional, setOptionalGiftcardAdditional] =
        useState('');
    const intl = useIntl();
    const messages = defineMessages({
        noGiftCard: {
            id: 'GiftCard.nocard',
            defaultMessage: 'Sorry we are out of Giftcards'
        },
        redeemNotice:{
            id:'GiftCard.redeem',
            defaultMessage:'These codes can only be redeemed on Amazon.com (US)'
        },
        redeemMethod:{
            id:'GiftCard.redeemMethod',
            defaultMessage:'How to redeem?'
        }
    });

    const getCode = async () => {
        try {
            const response = await axiosInterceptor().get('incas/giftcardv2');
            if (response.data && response.data.codes) {
                const codes = response.data.codes;
                setRequired(codes.required);
                setOptional(codes.optional);
                // setRequiredGiftcard(codes.required ? codes.required : '');
                // setOptionalGiftcard(codes.optional ? codes.optional : '');
                // setRequiredGiftcardAdditional(
                //     codes.requiredAdditional ? codes.requiredAdditional : ''
                // );
                // setOptionalGiftcardAdditional(
                //     codes.optionalAdditional ? codes.optionalAdditional : ''
                // );
                setShowCode(true);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getFormCodes = useCallback(() => {
        return (
            <Container>
                {required.length !== 0 && (
                    <>
                        {required.map((r) => {
                            return (
                                <Row key={r}>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <FormattedMessage
                                                    id="GiftCard.required"
                                                    defaultMessage="Reward for required surveys"
                                                />
                                            </Form.Label>
                                            <Form.Control
                                                value={
                                                    r === 'no card left'
                                                        ? intl.formatMessage(
                                                              messages.noGiftCard
                                                          )
                                                        : r
                                                }
                                                onChange={() => {}}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            );
                        })}
                    </>
                )}

                {optional.length !== 0 && (
                    <>
                        {optional.map((o) => {
                            return (
                                <Row key={o}>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                <FormattedMessage
                                                    id="GiftCard.optional"
                                                    defaultMessage="Reward for optional surveys"
                                                />
                                            </Form.Label>
                                            <Form.Control
                                                value={
                                                    o ===
                                                    'no card left'
                                                        ? intl.formatMessage(
                                                              messages.noGiftCard
                                                          )
                                                        : o
                                                }
                                                onChange={() => {}}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            );
                        })}
                    </>
                )}
            </Container>
        );
    }, [required, optional]);

    return (
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col
                            xs={12}
                            md={{ span: 8, offset: 2 }}
                            className="p-2"
                            style={{
                                boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.2)',
                                borderRadius: '10px'
                            }}
                        >
                            <Row>
                                <Col className="h5">{title}</Col>
                            </Row>
                            <Row>
                                <Col className="h6">
                                {intl.formatMessage(
                                    messages.redeemNotice
                                            )}
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-2 h6">
                                    <a
                                        href="https://www.amazon.com/gp/help/customer/display.html?nodeId=G5D4TA7NBKQT7GW2"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <u>{intl.formatMessage(
                                    messages.redeemMethod
                                            )}</u>
                                    </a>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    {!showCode ? (
                                        <Button
                                            variant="success"
                                            className="w-100"
                                            onClick={getCode}
                                        >
                                            <FormattedMessage
                                                id="GiftCard.showCode"
                                                defaultMessage="Show Giftcard Code"
                                            />
                                        </Button>
                                    ) : (
                                        getFormCodes()
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default ResultCard;
